import { Ban } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import type { ClientOrderStatus } from "@threadheads/shared";
import {
  CLIENT_ORDER_STATUS_CHIP_CLASS,
  CLIENT_ORDER_STATUS_LABEL_KEY,
} from "../utils/status-style";

interface ClientOrderStatusChipProps {
  status: ClientOrderStatus;
  className?: string;
}

/**
 * BLU-660 — the single, consistent status chip for the client order dashboard.
 * Fill colour + always-visible text label (colour is never the only signal —
 * DESIGN.md §16). Used in the list rows, the detail sheet header, and (in its
 * toggled form) the status filter.
 */
export function ClientOrderStatusChip({
  status,
  className,
}: ClientOrderStatusChipProps) {
  const { t } = useTranslation("clientOrders");

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-medium",
        CLIENT_ORDER_STATUS_CHIP_CLASS[status],
        className,
      )}
    >
      {status === "cancelled" ? (
        <Ban className="mr-1 h-3 w-3" aria-hidden="true" />
      ) : null}
      {t(CLIENT_ORDER_STATUS_LABEL_KEY[status])}
    </span>
  );
}
